var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.44112 1.05795C6.14035 0.25877 5.34742 -0.166602 4.58964 0.0611224L1.15229 1.09233C0.472635 1.29857 0 1.97744 0 2.75085C0 13.3808 7.83559 22 17.4992 22C18.2023 22 18.8195 21.4801 19.007 20.7325L19.9444 16.9514C20.1515 16.1178 19.7648 15.2456 19.0382 14.9148L15.2884 13.1961C14.6517 12.9039 13.9134 13.1059 13.4799 13.6945L11.9018 15.8128C9.15194 14.382 6.92548 11.9329 5.62475 8.908L7.55045 7.17643C8.08558 6.69521 8.26917 5.88743 8.00355 5.18707L6.44112 1.06225V1.05795Z",
    fill: "#E3B505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.77d026e071b09e54085e4a996f6d4581.svg";
export { ForwardRef as ReactComponent };